<script setup lang="ts">
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { EPreferredLanguage } from "fungi-types";
import { useStoreUserV2 } from "~/stores/storeUserV2";
import Trans from "~/modules/translations";
import { computed } from "vue";
import { useNotificationCenter } from "~/stores/storeNotificationCenter";

const userStore = useStoreUserV2();
const router = useRouter();
const i18n = useI18n();

const handleLanguageChange = async (newLocale: { id: string; label: string; value: string }) => {
  console.log(`Switching to ${newLocale}`);
  await Trans.switchLanguage(newLocale.id);

  try {
    await userStore.updatePreferredLanguage(newLocale.id as EPreferredLanguage, true);

    // Replace notifications with the new ones with correct language
    useNotificationCenter().fetchNotifications();

    await router.replace({ params: { locale: newLocale.id } });
  } catch (e) {
    console.error(`Error while changing user preferred language`);
  }
};

const langOptions = computed(() => {
  return Trans.supportedLocales.map((locale) => ({
    id: locale as EPreferredLanguage,
    label: i18n.t(`languages.${locale}`),
    value: locale,
  }));
});

const selectedId = computed(() => {
  return i18n.locale.value;
});
</script>

<template>
  <div>
    <div class="bg-slate-900 p-2 py-3 text-sm text-slate-400 mb-0.5 px-5 rounded-t-lg">
      {{ i18n.t("drawers.profile.settingsView.preferences.language") }}
    </div>

    <div class="gap-2 bg-slate-900 p-5 py-5 rounded-b-lg">
      <InputSelect
        width="full"
        :input-class="`!bg-slate-950 !border-0`"
        v-if="selectedId"
        :selectedId="selectedId"
        @onChange="handleLanguageChange"
        :options="langOptions"
      />
    </div>
  </div>
</template>
